// ----------------------------------------------------------------------
// <copyright file="Izenda.AreaChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  const { sortBy } = require('lodash/fp');

  module.exports = function(Highcharts) {
    var BASE_CHART = 'area';
    var IZENDA_CHART_NAME = 'izendaArea';

    var seriesTypes = Highcharts.seriesTypes;
    var defaultOptions = Highcharts.getOptions();
    var extend = Highcharts.extend;
    var extendClass = Highcharts.extendClass;

    /**
     * Extend the default options with AREA options
     */
    defaultOptions.plotOptions[IZENDA_CHART_NAME] = Highcharts.merge(defaultOptions.plotOptions[BASE_CHART], {});

    // Define izendaArea series type
    seriesTypes[IZENDA_CHART_NAME] = extendClass(seriesTypes[BASE_CHART], {
      type: IZENDA_CHART_NAME,
      izendaOptions: {
        spline: false
      },
      /**
       * Override the init method to use area or areaspline chart type
       */
      init: function(chart, data) {

        var izendaOptions = chart.options.izendaOptions || {};

        if (izendaOptions.spline) {
          // extend spline chart type
          extend(this, new seriesTypes.areaspline);
          return seriesTypes.areaspline.prototype.init.apply(this, arguments);
        }

        return seriesTypes[BASE_CHART].prototype.init.apply(this, arguments);
      },

      /**
       * Override getStackPoints method
       * Highcharts area bug - for x-axis type = datetime, value of x is sorted by STRING
       * should be sort by datetime
       */
      getStackPoints: function(chart, data) {
        var stacks = seriesTypes[BASE_CHART].prototype.getStackPoints.apply(this, arguments);

        return sortBy(function(point) {
          return point.x; // sort by its data type > can be numberic or datetime
        }, stacks);
      }
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.AreaChart.js